const styles = {
  clauseTextContainer: {
    maxHeight: '63vh',
  },
  clauseText: {
    marginTop: '12px',
    marginBottom: '12px',
    lineHeight: '24px',
  },
  clauseTitle: {
    alignSelf: 'flex-start',
    marginTop: '16px',
    fontWeight: '500', // TODO: update to body-medium once is ready
  },
};

export default styles;
